import axios from '../AxiosInstance';
import { getApiUrl } from '../../utils/ApiUtils';

/**
 * Admin ToDo aggregator — fans out across expense/time-report/tax-report
 * contributors on the backend and returns one flat response:
 *
 *   { groups: TodoGroup[], errors: [{contributor, message}], generatedAt, totalCount }
 *
 * Non-admins get 403 (backend-gated). Caller should treat 403 as "no todos".
 */
export const fetchTodos = (companyId) =>
  axios.get(getApiUrl(`${companyId}/dashboard/todos`), { withCredentials: true });

/**
 * Decide a staged agent (AI) action. The backend enforces the authz tier —
 * 'needs-owner' approvals return 403 unless the caller holds the owner role —
 * and proxies to the agent platform, which resumes the run and commits.
 * The commit runs synchronously; allow a generous timeout.
 */
export const decideAgentApproval = (companyId, approvalId, decision, actionBinding) =>
  axios.post(
    getApiUrl(`${companyId}/agent-approvals/${approvalId}/${decision}`),
    actionBinding ? { actionBinding } : {},
    { withCredentials: true, timeout: 70000 },
  );
